// extracted by mini-css-extract-plugin
module.exports = {"merged-items-modal__body":"MergedItemsModal_merged-items-modal__body__HPkLW"};